import ProductFilter from "@root/modules/ProductPage/ProductFilter";
new ProductFilter();
